import React from "react";
import { Link } from "react-router-dom";
import { Typography } from "antd";
import classnames from "classnames";

import { AppPathNames } from "@/constants/AppPathNames";

import "./AppLogo.scss";

const { Text } = Typography;

const AppLogo = ({ className, imageClassName, withTitle = true, to, imgName }) => {
  return (
    <Link
      className={classnames("app-logo", {
        [className]: className,
        "app-logo__disable-link": !to,
      })}
      to={to ?? AppPathNames.root}
    >
      <img
        className={classnames("app-logo__image", {
          [imageClassName]: imageClassName,
        })}
        src={"/images/" + imgName}
        alt="averroes logo"
      />
      {withTitle && (
        <Text className="app-logo__text" strong>
          AVERROES
        </Text>
      )}
    </Link>
  );
};

export default AppLogo;
